import { Link } from 'react-router-dom';

interface EmptyStateProps {
  type: 'no-orders' | 'no-results' | 'error';
  onClearFilters?: () => void;
  onRetry?: () => void;
}

const EmptyState = ({ type, onClearFilters, onRetry }: EmptyStateProps) => {
  if (type === 'no-orders') {
    return (
      <div className="bg-white rounded-lg shadow-sm p-12 text-center">
        <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-gray-100 rounded-full">
          <i className="ri-shopping-bag-line text-5xl text-gray-400"></i>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          You have no orders yet
        </h3>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          Place your first carton-based wholesale order and track it here.
        </p>
        <Link
          to="/products"
          className="inline-flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap"
        >
          <i className="ri-shopping-cart-line mr-2"></i>
          Browse Products
        </Link>
      </div>
    );
  }

  if (type === 'no-results') {
    return (
      <div className="bg-white rounded-lg shadow-sm p-12 text-center">
        <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-gray-100 rounded-full">
          <i className="ri-search-line text-5xl text-gray-400"></i>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          No orders match your filters
        </h3>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          Try adjusting your search criteria or clearing filters to find what you're looking for.
        </p>
        {onClearFilters && (
          <button
            onClick={onClearFilters}
            className="inline-flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap"
          >
            <i className="ri-close-circle-line mr-2"></i>
            Clear Filters
          </button>
        )}
      </div>
    );
  }

  if (type === 'error') {
    return (
      <div className="bg-white rounded-lg shadow-sm p-12 text-center">
        <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-red-100 rounded-full">
          <i className="ri-error-warning-line text-5xl text-red-500"></i>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Failed to load orders
        </h3>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          Please try again later or contact support if the problem persists.
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap"
          >
            <i className="ri-refresh-line mr-2"></i>
            Retry
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default EmptyState;
